// extracted by mini-css-extract-plugin
export default {"loader":"loaderComponent_loader__i3MJQ"};